/* eslint-disable */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogContent, Popover } from '@mui/material';
import deleteParameterIcon from '../../../../../../Assets/images/svg/dar_delete_parameter.svg';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from './addDialog.module.scss';
import { v4 as uuidv4 } from 'uuid';

const ParameterDialog = ({
  parameterData,
  handleParameterValueChange,
  handleAddChild,
  handleDelete,
  childrenElements,
  dealTypes
}) => {
  return (
    <div>
      <div className={styles['flex-between']}>
        <div
          style={{
            fontFamily: 'Mukta-Medium',
            color: '#7A757F',
            fontSize: '12px',
          }}
        >
          {parameterData.parameter}
        </div>

        <button
          onClick={() => handleDelete(parameterData.id)}
          aria-label="Delete"
          style={{
            background: `url(${deleteParameterIcon})`,
            height: '16px',
            width: '16px',
            border: 'none',
            cursor: 'pointer',
          }}
        />
      </div>
      <div
          style={{
            display: 'flex',
            gap: '10px',
          }}
        >
          {parameterData.parameter === 'Deal Type' || parameterData.parameter === 'Vertical' ? (
            <select
              style={{
                flex: 1,
                height: '33px',
                padding: '0px 10px',
                borderRadius: '4px',
                border: '1px solid #CAC4CF',
                backgroundColor: '#FFFFFF',
                minWidth: '100px',
              }}
              value={parameterData.parameterFromDD || ''}
              onChange={(e) =>
                handleParameterValueChange(parameterData.id, 'parameterFromDD', e.target.value)
              }
              >
              <option value="">
                {parameterData.parameter === 'Deal Type'
                  ? 'Select Deal Type'
                  : 'Select Vertical'}
              </option>
              {parameterData.parameter === 'Deal Type' && (
                <>
                  {dealTypes.map(option => (
                  <option key={option.id} value={option.name}>{option.name}</option>
                ))}
                </>
              )}
              {parameterData.parameter === 'Vertical' && (
                <>
                  <option value="Infra Mod">Infra Mod</option>
                  <option value="App Mod">App Mod</option>
                  <option value="Data Mod">Data Mod</option>
                </>
              )}
            </select>
          ) : (
            <>
              <input
                placeholder="Parameter Value From"
                style={{
                  flex: 1,
                  height: '33px',
                  padding: '0px 10px',
                  borderRadius: '4px',
                  border: '1px solid #CAC4CF',
                  minWidth: '80px',
                }}
                value={parameterData.parameterValueFrom || ''}
                onChange={(e) =>
                  handleParameterValueChange(parameterData.id, 'parameterValueFrom', e.target.value)
                }
              />
              <input
                placeholder="Parameter Value To"
                style={{
                  flex: 1,
                  height: '33px',
                  padding: '0px 10px',
                  borderRadius: '4px',
                  border: '1px solid #CAC4CF',
                  minWidth: '80px',                  
                }}
                value={parameterData.parameterValueTo || ''}
                onChange={(e) =>
                  handleParameterValueChange(parameterData.id, 'parameterValueTo', e.target.value)
                }             />
            </>
          )}
        </div>
      <div style={{ display: 'flex', gap: '10px' }}>
        <button
          type="button"
          style={{
            fontFamily: 'Mukta-SemiBold',
            color: '#6B5CE8',
            fontSize: '14px',
            cursor: 'pointer',
            background: 'none',
            border: 'none',
            padding: 0,
          }}
          onClick={(e) => handleAddChild(e, parameterData.id)}
        >
          Add parameter
        </button>
        <ExpandMoreIcon sx={{ color: '#6B5CE8' }} />
      </div>

      {childrenElements}
    </div>
  );
};

ParameterDialog.propTypes = {
  parameterData: PropTypes.shape({
    id: PropTypes.string.isRequired,
    parameter: PropTypes.string.isRequired,
    parameterValueFrom: PropTypes.string,
    parameterValueTo: PropTypes.string,
    parameterFromDD: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  handleParameterValueChange: PropTypes.func.isRequired,
  handleAddChild: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  childrenElements: PropTypes.node,
  dealTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};

const updateParameterValue = (array, id, field, value) => {
  return array.map((item) => {
    if (item.id === id) {
      return { ...item, [field]: value };
    }
    if (item.children.length > 0) {
      return {
        ...item,
        children: updateParameterValue(item.children, id, field, value),
      };
    }
    return item;
  });
};

const AddDialog = ({ isOpen, onClose, anchorEl: initialAnchorEl, addData,parameters,alignment,dealTypes }) => {
  const [anchorEl, setAnchorEl] = useState(initialAnchorEl);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedParentId, setSelectedParentId] = useState(null);
  const [parametersData, setParametersData] = useState([]);

  const addChildToParent = (array, parentId, newChild) => {
    return array.map((item) => {
      if (item.id === parentId) {
        return { ...item, children: [...item.children, newChild] };
      }
      if (item.children.length > 0) {
        return {
          ...item,
          children: addChildToParent(item.children, parentId, newChild),
        };
      }
      return item;
    });
  };

  const handleParameterSelect = (parameter) => {
    const newParameter = {
      id: uuidv4(),
      parameter,
      parameterValueFrom: '',
      parameterValueTo: '',
      children: [],
    };

    if (selectedParentId) {
      setParametersData((prev) =>
        addChildToParent(prev, selectedParentId, newParameter)
      );
    } else {
      setParametersData((prev) => [...prev, newParameter]);
    }

    setAnchorEl(null);
  };

  const handleSave = () => {
        let result = arrayToObjectWithDetails(parametersData);
        addData(result);
    setParametersData([]);
    setOpenDialog(false);
    onClose()
  };

  function arrayToObjectWithDetails(array) {
    if (!array || array.length === 0) return null;

    const detailsTemplate = {
      details: {
        firstApprover: "",
        firstApproverId: 56,
        secondApprover: "",
        secondApproverId: 57,
        thirdApprover: "",
        thirdApproverId: 58,
        market: "India",
        marketId: 8,
        vertical: "",
        verticalId: 49,
        industry: "",
        industryId: 11,
        isApprovalSerial: true,
      },
    };

    const convert = (item) => {
      const { id, parameter, parameterValueFrom, parameterValueTo,parameterFromDD, children } = item;

      return {
        id,
        parameter,
        parameterValueFrom,
        parameterValueTo,
        parameterFromDD,
        parameterValueId: alignment === 'Commercial workflow' ? 1 : 49,
        parameterLabel: parameterFromDD ||`${parameterValueFrom.trim()} - ${parameterValueTo.trim()}`,
        ...(children.length > 0
          ? { children: children.map(convert) }
          : detailsTemplate),
      };
    };

    const [root] = array;
    return convert(root);
  }


  const handleParameterValueChange = (id, field, value) => {
    setParametersData((prev) => updateParameterValue(prev, id, field, value));
  };

  const handleAddChild = (event, parentId) => {
    handlePopoverOpen(event, parentId);
  };

  const handlePopoverOpen = (event, parentId = null) => {
    if (event) {
      setAnchorEl(event.currentTarget);
      setSelectedParentId(parentId);
    }
  };

  const deleteParameter = (array, id) => {
    return array
      .filter((item) => item.id !== id)
      .map((item) => ({
        ...item,
        children: deleteParameter(item.children, id),
      }));
  };

  const handleDelete = (id) => {
    setParametersData((prev) => deleteParameter(prev, id));
  };

  const renderChildElements = (childrenArray, level = 1) => {
    const backgroundColor = level % 2 === 1 ? '#F1F5F8' : 'white';

    return childrenArray.map((child) => (
      <div
        key={child.id}
        style={{
          padding: '20px',
          marginTop: '10px',
          background: backgroundColor,
          borderRadius: '4px',
        }}
      >
        <ParameterDialog
          parameterData={child}
          handleParameterValueChange={handleParameterValueChange}
          handleAddChild={handleAddChild}
          handleDelete={handleDelete}
          childrenElements={renderChildElements(child.children, level + 1)}
          dealTypes={dealTypes}
        />
      </div>
    ));
  };

  return (
    <div>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div style={{ padding: '10px' }}>
          {parameters.map((parameter) => (
            <Button
              key={parameter}
              onClick={() => {
                handleParameterSelect(parameter);
                setOpenDialog(true);
              }}
              sx={{
                fontFamily: 'mukta-regular',
                color: '#49454E',
                '&:hover': {
                  backgroundColor: '#ECEDF4',
                  color: '#6B5CE8',
                },
              }}
              style={{ display: 'block', marginBottom: '5px' }}
            >
              {parameter}
            </Button>
          ))}
        </div>
      </Popover>

      <Dialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
          onClose();  
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            width: '696px',
            maxHeight: '400px',
          },
        }}
      >
        <header
          className={styles['header']}
        >
          Add {alignment} 
        </header>
        <DialogContent>
          {parametersData.map((param) => (
            <ParameterDialog
              key={param.id}
              parameterData={param}
              handleParameterValueChange={handleParameterValueChange}
              handleAddChild={handleAddChild}
              handleDelete={handleDelete}
              childrenElements={renderChildElements(param.children, 1)}
              dealTypes={dealTypes}
            />
          ))}
        </DialogContent>
        <footer className={styles['footer']}>
          <button
           onClick={() => {
            setOpenDialog(false);
            onClose();  
          }}
            className={styles['cancel-button']}
          >
            Cancel
          </button>
          <button onClick={handleSave} className={styles['save-button']}>
            Save
          </button>
        </footer>
      </Dialog>
    </div>
  );
};

AddDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  anchorEl: PropTypes.object,
  addData: PropTypes.func.isRequired,
  parameters: PropTypes.arrayOf(PropTypes.string).isRequired,
  alignment: PropTypes.string.isRequired,
  dealTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default AddDialog;
